export default __webpack_public_path__ + "static/media/background.eabcaa6d.png";